import React from 'react';
import styled, { css, keyframes, useTheme } from 'styled-components';
import { Absolute } from '../Absolute/Absolute';
import { Flex } from '../Flex/Flex';
import { applySizes, getPaletteColor } from '../utils/utils';
import { Animate } from './../Animate/Animate';
const sizes = {
  small: css(["width:48px;height:48px;& > svg{width:20px;height:20px;}"]),
  medium: css(["width:64px;height:64px;& > svg{width:24px;height:24px;}"]),
  large: css(["width:96px;height:96px;& > svg{width:36px;height:36px;}"])
};
const RelativeFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "Spinner__RelativeFlex",
  componentId: "sc-1jqdl3q-0"
})(["position:relative;", ";"], applySizes(sizes, null));
const rotate = /*#__PURE__*/keyframes(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
const Ring = /*#__PURE__*/styled.div.withConfig({
  displayName: "Spinner__Ring",
  componentId: "sc-1jqdl3q-1"
})(["position:absolute;top:0;left:0;width:100%;height:100%;border:2px solid ", ";border-top:2px solid ", ";border-radius:50%;animation:", " 1s linear infinite;"], getPaletteColor('base'), getPaletteColor('background.lightest'), rotate);
const GradientRingWrapper = /*#__PURE__*/styled(Absolute).withConfig({
  displayName: "Spinner__GradientRingWrapper",
  componentId: "sc-1jqdl3q-2"
})(["position:absolute;top:0;left:0;width:100%;height:100%;"]);
function GradientRing({
  strokeWidth = '6px',
  ...props
}) {
  const strokeColor = getPaletteColor(props.color, 'base')(props);
  return React.createElement(GradientRingWrapper, {
    mt: '-3px'
  }, React.createElement(Animate, {
    variant: 'spin'
  }, React.createElement("svg", {
    width: '100%',
    height: '100%',
    viewBox: '0 0 200 200',
    color: strokeColor,
    fill: 'none',
    overflow: 'visible'
  }, React.createElement("defs", null, React.createElement("linearGradient", {
    id: 'spinner-secondHalf'
  }, React.createElement("stop", {
    offset: '0%',
    "stop-opacity": '0',
    "stop-color": 'currentColor'
  }), React.createElement("stop", {
    offset: '100%',
    "stop-opacity": '0.5',
    "stop-color": 'currentColor'
  })), React.createElement("linearGradient", {
    id: 'spinner-firstHalf'
  }, React.createElement("stop", {
    offset: '0%',
    "stop-opacity": '1',
    "stop-color": 'currentColor'
  }), React.createElement("stop", {
    offset: '100%',
    "stop-opacity": '0.5',
    "stop-color": 'currentColor'
  }))), React.createElement("g", {
    "stroke-width": strokeWidth
  }, React.createElement("path", {
    stroke: 'url(#spinner-secondHalf)',
    d: 'M 4 100 A 96 96 0 0 1 196 100'
  }), React.createElement("path", {
    stroke: 'url(#spinner-firstHalf)',
    d: 'M 196 100 A 96 96 0 0 1 4 100'
  }), React.createElement("path", {
    stroke: 'currentColor',
    "stroke-linecap": 'round',
    d: 'M 4 100 A 96 96 0 0 1 4 98'
  })))));
}
/**
 * @public
 */
export function Spinner({
  children,
  color = 'primary',
  size = 'medium',
  useGradient = false,
  ...props
}) {
  if (children) {
    React.Children.only(children);
  }
  const theme = /*#__PURE__*/useTheme();
  return React.createElement(RelativeFlex, {
    justifyContent: 'center',
    alignItems: 'center',
    size: size,
    ...props
  }, useGradient ? React.createElement(GradientRing, {
    color: color,
    theme: theme,
    ...props
  }) : React.createElement(Ring, {
    color: color
  }), children && React.isValidElement(children) && React.cloneElement(children, {
    color: children?.props?.color || color
  }));
}